import { recipesTr } from './recipes-tr';
import { batchScalingTr, processRoutingTr } from './process-routing-tr';
import { declarationsTr } from './declarations-tr';
import { analysisTr } from './analysis-tr';

export const plmTr = {
  material: {
    tab: 'Ürün geliştirme',
    roles: {
      TRADING_GOOD: 'Ticari ürün',
      RAW_MATERIAL: 'Hammadde',
      SEMI_FINISHED: 'Yarı mamul',
      FINISHED_GOOD: 'Mamul',
      PACKAGING_MATERIAL: 'Ambalaj malzemesi',
      OPERATING_SUPPLY: 'İşletme malzemesi',
      BY_PRODUCT: 'Yan ürün',
    },
    sections: {
      roles: 'Kullanım rolleri',
      versions: 'Sürümlü ana veri profilleri',
      translations: 'Çok dilli adlar',
    },
    help: {
      roles:
        'Bir ürün aynı anda birden fazla role sahip olabilir. Değişiklikler sürüm kontrolüyle kaydedilir.',
      structuredJson:
        'Geçerli bir JSON nesnesi olarak yapılandırılmış anahtar ve değerler. Hesaplama sayıları ondalık metin olarak girilir.',
      conversions:
        'fromUnitCode, toUnitCode, factor, offset, roundingScale ve usesDensity içeren JSON listesi.',
      dms: 'Yalnızca bu ürünün korumalı DMS dosyasındaki belgeler seçilebilir.',
    },
    messages: {
      saved: 'Ana veri sürümü kaydedildi.',
      invalid: 'Girdiler geçersiz.',
      rolesSaved: 'Kullanım rolleri kaydedildi.',
      workflowUpdated: 'İş akışı güncellendi.',
      submitted: 'Sürüm incelemeye gönderildi.',
    },
    states: {
      noApproved: 'Henüz onaylanmış ana veri sürümü yok.',
      approvedVersion: 'Onaylı sürüm: v{{version}}',
      empty: 'Henüz ana veri sürümü yok.',
      noDocuments: 'Ürün dosyasında henüz DMS belgesi yok.',
    },
    actions: {
      newVersion: 'Yeni sürüm',
      submit: 'İncelemeye gönder',
      approve: 'Onayla',
      copy: 'Yeni sürüme kopyala',
      archive: 'Arşivle',
      confirm: 'Onayla',
    },
    columns: {
      version: 'Sürüm',
      status: 'Durum',
      validity: 'Geçerlilik',
      names: 'Ad',
      suppliers: 'Tedarikçi anlık görüntüsü',
    },
    statuses: {
      DRAFT: 'Taslak',
      IN_REVIEW: 'İncelemede',
      APPROVED: 'Onaylandı',
      SUPERSEDED: 'Değiştirildi',
      ARCHIVED: 'Arşivlendi',
    },
    editor: {
      createTitle: 'Ana veri sürümü oluştur',
      editTitle: 'Ana veri sürümü v{{version}} düzenle',
      description:
        'Onaylı sürümler değiştirilemez. Tedarikçi bilgileri kayıtta sunucu tarafında anlık görüntü olarak alınır.',
    },
    fields: {
      usageRoles: 'Kullanım rolleri',
      standardUnit: 'Standart miktar birimi',
      shelfLifeDays: 'Raf ömrü (gün)',
      density: 'Yoğunluk',
      densityUnit: 'Yoğunluk birimi',
      originCountry: 'Menşe ülke',
      originRegion: 'Menşe bölgesi',
      manufacturer: 'Üretici',
      manufacturerAddress: 'Üretici adresi',
      validFrom: 'Geçerlilik başlangıcı',
      validTo: 'Geçerlilik sonu',
      internalName: 'Dahili ad',
      externalName: 'Harici ad',
      declarationName: 'Beyan adı',
      storageInstructions: 'Saklama talimatı',
      technicalProperties: 'Teknik özellikler',
      qualityProperties: 'Kalite özellikleri',
      storageConditions: 'Saklama koşulları',
      foodProfile: 'İsteğe bağlı gıda profili',
      nutritionProfile: 'İsteğe bağlı besin profili',
      allergenInformation: 'İsteğe bağlı alerjen bilgileri',
      additiveInformation: 'İsteğe bağlı katkı bilgileri',
      extensionProfiles: 'Sektöre özel ek profiller',
      conversions: 'Ürüne özel dönüşüm faktörleri',
      dmsDocuments: 'DMS belgeleri ve tedarikçi şartnameleri',
      changeReason: 'Değişiklik nedeni',
      reason: 'Gerekçe',
    },
    actionDialog: {
      APPROVE: {
        title: 'Ana veriyi onayla',
        description:
          'Onay denetime dayanıklıdır ve oluşturan/gönderen kullanıcıdan farklı bir kullanıcı gerektirir.',
      },
      COPY: {
        title: 'Yeni sürüm oluştur',
        description:
          'İçerik yeni düzenlenebilir taslağa kopyalanır ve tedarikçiler yeniden görüntülenir.',
      },
      ARCHIVE: {
        title: 'Sürümü arşivle',
        description: 'Sürüm tamamen izlenebilir kalır ancak artık aktif olarak kullanılmaz.',
      },
    },
  },
  recipes: recipesTr,
  processRouting: processRoutingTr,
  batchScaling: batchScalingTr,
  declarations: declarationsTr,
  analysis: analysisTr,
} as const;
